import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CTooltip,
  CButton,
  CFormTextarea,
} from '@coreui/react';
import { fetchAuthSession  } from 'aws-amplify/auth';
import AWS from '../../aws-mock';
import CIcon from '@coreui/icons-react'
import {cilReload,cilHappy,cilTrash} from '@coreui/icons';
import EmojiPicker, {
  Theme,
  EmojiClickData, 
} from "emoji-picker-react";

function Billing() {

  const REGION ='us-east-1';

  const dynamodb = new AWS.DynamoDB.DocumentClient({
    region: REGION,
    credentials: new AWS.Credentials({
      accessKeyId: process.env.REACT_APP_ACCESSKEYID,
      secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
    }),
  });
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {

          setInterval(() => {
            leercomentarios();
            leerpremium();
            setLoading(false);
          }, 1300);

          setNombre(data.tokens.idToken.payload.name);
          setSub(data.tokens.accessToken.payload.username);
          comprobarAdmin(data.tokens.accessToken.payload.username);

        });

      } catch (err) {
        console.log(err);
      }

    })();	
	},[]);

  const [datos,SetDatos] = useState([]); 
  const [nombre,setNombre] = useState();
  const [usuario,setSub] = useState();
  const [base,SetDB] = useState([]);
  const [educacion,SetUNI] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [esAdmin, setEsAdmin] = useState(false);

  async function leercomentarios() { 
    let params = {
      "TableName":"codeflex_comentarios"
    };
    dynamodb.scan(params, function(err, data) {
        if (err) {
            console.error("Unable to read item de Proyecto_semillero. Error JSON:", JSON.stringify(err, null, 2));
          } else {
            let comentariosOrdenados = data.Items.sort((a, b) => new Date(b.timeid) - new Date(a.timeid));
            SetDatos(comentariosOrdenados);
        }
    });
  }

  async function leerpremium() {
    let params = {
      "TableName":"codeflex"
    };
    dynamodb.scan(params, function(err, data) {
        if (err) {
            console.error("Unable to read item de Proyecto_semillero. Error JSON:", JSON.stringify(err, null, 2));
        } else { 
          const premium = data.Items.filter(user => user.premium); // Asumiendo que la columna se llama 'premium'
          const educa = data.Items.filter(user => user.plan === 'EDUCACION');
          SetUNI(educa);
          SetDB(premium);
        }
    });
  }


  async function enviarcomentario() {
    if(mensaje.length > 0 ){
      let admin;
      if(usuario == "invitado"){
        admin = true;
      }else{
        admin = false;
      }
    const params = {
      TableName: "codeflex_comentarios",
      Item: {
        usuario: usuario,
        comentario: mensaje,
        admin: admin,
        verificado: false,
        autor: nombre,
        timeid: new Date().toISOString(),
      },
    };
    dynamodb.put(params, (err, data) => { 
      alert("Comentario Publicado.")
      setMensaje('')
    });
    }else{
      alert("No se puede enviar un comentario vacio.")
    }
  }


  function eliminarcomentario(user,timeid) {

    if(usuario == user){
      var params = {
        TableName:"codeflex_comentarios",
        Key:{
            "usuario": usuario,
            "timeid": timeid
        }
    };
    dynamodb.delete(params, function(err, data) {
        if (err) {
          console.error("Unable to read item de parametros. Error JSON:", JSON.stringify(err, null, 2));
        } else {
           alert("Comentario Eliminado.")
        }
    });

    } else if (usuario == "invitado") {
      var params = {
        TableName:"codeflex_comentarios",
        Key:{
            "usuario": user,
            "timeid": timeid
        }
      };
      dynamodb.delete(params, function(err, data) {
          if (err) {
            console.error("Unable to read item de parametros. Error JSON:", JSON.stringify(err, null, 2));
          } else {
            alert("Comentario Eliminado Admin.")
          }
      });
  } else {
    alert('El usuario: ' + usuario + ' no es dueño de este comentario.');
  }
}

const refrescar = () => {
  window.location.reload()
};

const [showEmojiPicker, setShowEmojiPicker] = useState(false);

function onEmojiClick(emojiData: EmojiClickData, event: MouseEvent) {
  setMensaje(
    (inputValue) =>
      inputValue + (emojiData.isCustom ? emojiData.unified : emojiData.emoji)
  );

}

const styles = {
  comentarioBox: {
    boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
    transition: '0.3s',
    borderRadius: '5px',
    padding: '10px',
    marginBottom: '10px',
  },
  comentarioHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  comentarioText: {
    marginTop: '10px',
  },
  emojiPicker: {
    position: 'absolute',
    bottom: '100%',
    right: '0',
  },
};

const esPremium = (autor) => {
  return base.some(user => user.token === autor);
};

const esEducacion = (autor) => {
  return educacion.some(user => user.token === autor);
};

const comprobarAdmin = async (usuario) => {
  let params = {
      "TableName": "codeflex_comentarios",
      "FilterExpression": "usuario = :usuario",
      "ExpressionAttributeValues": { ":usuario": usuario }
  };

  try {
    const data = await dynamodb.scan(params).promise();
    if (data.Items.length > 0 && data.Items[0].admin) {
      setEsAdmin(true);
    } else {
      setEsAdmin(false);
    }
  } catch (err) {
      console.error("Error al verificar si el usuario es admin: ", err);
      setEsAdmin(false);
  }
};


const blogStyles = {
  card: {
    borderRadius: '6px',
    marginBottom: '1rem',
    backgroundColor: '#f8f9fa', // Color de fondo suave
  },
  textarea: {
    width: '100%', // Ancho completo
    resize: 'vertical', // Permitir solo redimensionamiento vertical
  },
  header: {
    backgroundColor: '#007bff', // Color de fondo del encabezado
    color: 'white', // Color de texto del encabezado
  },
  header2: {
    backgroundColor: 'black', // Color de fondo del encabezado
    color: 'white', // Color de texto del encabezado
  },
  commentSection: {
    padding: '1rem',
    border: '1px solid #dee2e6', // Bordes para la sección de comentarios
  },
  comment: {
    marginBottom: '0.5rem',
  },
};


const leyendaRoles = () => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px', padding: '10px',  borderRadius: '6px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', marginBottom: '20px' }}>
    {[
      { src: "https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595571.png", text: "Administrador", color: '#3D3D3D' },
      { src: "https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595573.png", text: "Plan Premium", color: '#3D3D3D' },
      { src: "https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595572.png", text: "Plan Gratuito", color: '#3D3D3D' },
      { src: "https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/458755.png", text: "Institucional", color: '#3D3D3D' }
    ].map((role, index) => (
    
      <div key={index} style={{ display: 'flex', alignItems: 'center', padding: '10px', backgroundColor: role.color, color: 'white', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', transition: 'transform 0.3s ease', ':hover': { transform: 'scale(1.05)' } }}>
        <img src={role.src} alt={role.text} style={{ width: '30px', marginRight: '10px' }} />
        <span>{role.text}</span>
      </div>

    ))}
  </div>
);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>



      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={{ borderRadius: '6px' }}>
          <CCardHeader style={blogStyles.header}>
            <strong>Publicar</strong> <small>/</small>
          </CCardHeader> 
          <CCardBody>
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                <CCol md={6} style={{ width: '100%' }}>
				  
				<div style={{ width: "100%", display: 'grid', gridTemplateColumns: '10fr 1fr ', gap: '30px', alignItems: 'center' }}>
                  <div>
					<CFormTextarea
                    maxLength="3600"
                    size="sm"
                    id="exampleFormControlTextarea1" 
                    label="Texto de entrada"
                    rows={1}
                    value={mensaje}
                    onChange={(e) => setMensaje(e.target.value)}
                    required
                  ></CFormTextarea>
                  </div>
                  <div >
                  <CButton style={{ position: 'absolute',  bottom: '70px'}} color="warning" onClick={() => setShowEmojiPicker(!showEmojiPicker)}><CIcon icon={cilHappy} /></CButton>
                  </div>
                </div>
				  
                </CCol>
                  <CCol xs={12}>
                    <div className="d-flex">
                      <CButton onClick={enviarcomentario}>Publicar</CButton> &nbsp;&nbsp;
                      <CButton color="success" shape="rounded-pill"  onClick={() => refrescar()}>
                        <CIcon  icon={cilReload}  />
                      </CButton> &nbsp;&nbsp;
                      <div className="position-relative">
                        {showEmojiPicker && (
                          <EmojiPicker
                            width="310px"
                            height={410}
                            theme={Theme.DARK}
                            autoFocusSearch={false}
                            onEmojiClick={onEmojiClick}
                            style={{ position: 'absolute', right: '0', bottom: '-350px', zIndex: '1000' }}
                          />
                        )}
                      </div>
                    </div>
                  </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
        </CCard>
      </CCol>
	  <br/>


      <CCol xs={12}>
        <CCard className="mb-4 ccard-custom-style" style={blogStyles.card}>
          <CCardHeader style={blogStyles.header}>
            <strong>Comentarios</strong> <small>/ <strong style={{fontSize:"15px"}}>({datos.length})</strong></small>
          </CCardHeader>
          {leyendaRoles()}

          {datos.length ? 
          <>
          {datos.map((result, index) => (
          <CCardBody key={index}> 
            <CCard>
              <CCardBody style={{ borderRadius: '6px' }}>
                <div className="row g-3">
                  <CCol md={6} style={{ width: '100%' }}>
                    <div className="comentario" style={styles.comentarioBox}>
                      <div style={styles.comentarioHeader}>
                        <strong>{result.autor}
						            {result.admin ?  
                        <CTooltip
                        content="Administrador" 
                        placement="top" 
                        >
                          <img src="https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595571.png" style={{width:"20px"}}></img>
                        </CTooltip>
                        :
                        <> 
                          {esEducacion(result.usuario) ?  
                            <CTooltip 
                            content="Plan Institucional"
                            placement="top"
                            >
                            <img src="https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/458755.png" style={{width:"20px"}}></img>
                            </CTooltip>
                            :
                            <>
                            {esPremium(result.usuario) ?  
                              <CTooltip
                              content="Plan Premium"
                              placement="top"
                              >
                              <img src="https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595573.png" style={{width:"20px"}}></img>
                              </CTooltip>
                              :
                              <CTooltip
                              content="Plan Gratuito"
                              placement="top"
                              >
                              <img src="https://s3.amazonaws.com/www.codeflex.lat/documentos/76527625-b9dd-4efe-a987-6374f56e3d22/Pdf/7595572.png" style={{width:"20px"}}></img>
                              </CTooltip>
                            }
                          </>      
                          }
                        </>
                        }
                        </strong>

                        {esAdmin ?  
                          <CButton color="danger" variant="outline" size="sm" onClick={(e) => eliminarcomentario(result.usuario,result.timeid)}><CIcon icon={cilTrash} /></CButton>
                          :
                          <>
                            {result.usuario == usuario ?  
                               <CButton color="danger" variant="outline" size="sm" onClick={(e) => eliminarcomentario(result.usuario,result.timeid)}><CIcon icon={cilTrash} /></CButton>
                              :
                              <></>
                            }
                          </>      
                        }

                      </div>
                      <p style={styles.comentarioText}>{result.comentario}</p>

                      <hr/>
                      <CTooltip
                          content="Fecha de publicación"
                          placement="bottom"
                        >
                        <strong><i><small >Fecha: {new Date(result.timeid).toLocaleString()}</small></i></strong>
                      </CTooltip>
                    </div>
                </CCol>
                </div>
              </CCardBody>
            </CCard>
          </CCardBody>
         ))}     
        </>
          :  
          <center><div style={{fontSize:"20px", backgroundColor:"#f1f4f4"}}>Esperando Comentarios...</div></center>
        } 

        </CCard>
      </CCol>

      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
